import React, { Component } from 'react';
import { PageHeader, PageTitle, PdfViewer, Spinner } from '../../components/index.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
  selectActiveTrainingMaterialLoading, 
  selectActiveTrainingMaterialData, 
  selectActiveTrainingMaterialError 
} from '../../reducers/trainingReducer.js';
import { fetchActiveTrainingMaterial } from '../../actions/trainingActions.js';

export class TrainingMaterialViewer extends Component {
  componentDidMount() {
    const { fetchActiveTrainingMaterial } = this.props;
    fetchActiveTrainingMaterial();
  }

  render() {
    const { loading, trainingMaterialData, error } = this.props;
    const pdfUrl = trainingMaterialData?.downloadUrl;
    
    return (
      <div className="userpage">
        <div className="pdf-align-items pdf-page-bottom-align">
          <PageTitle title="Training Materials" />
          <PageHeader title="Training Materials">
            <div className="user-page">
              <i className="fas fa-graduation-cap"></i>
            </div>
          </PageHeader>
          <div id="training-material-pdf"></div>
          {loading ? (
            <Spinner large text="Fetching Training Material..." />
          ) : error ? (
            <div className="text-center p2 text-color-error">{error}</div>
          ) : pdfUrl ? (
            <PdfViewer s3DataUrl={pdfUrl} containerId="training-material-pdf" />
          ) : (
            <div className="text-center p2">No training material available</div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: selectActiveTrainingMaterialLoading(state),
  trainingMaterialData: selectActiveTrainingMaterialData(state),
  error: selectActiveTrainingMaterialError(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchActiveTrainingMaterial
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TrainingMaterialViewer);
